/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { useTranslation } from 'react-i18next';
import { BodyText, Flex, Form, Heading, Size, TextArea, Button, ButtonType, Icon } from '@vaisala-rockhopper/components';
import { ModalInstance, ModalProps } from './Modals';
import './Modals.scss';
import { useEffect, useState } from 'react';
import createShareUrl from '../configuration/CreateShareUrl';
import { VaiIcon } from '@vaisala-rockhopper/design-tokens';

const ContactModal = (props: ModalProps) => {
  const { t } = useTranslation();
  const [shareUrl, setShareUrl] = useState("");

  useEffect(() => {
    setShareUrl(createShareUrl)
  }, [])

  useEffect(() => {
    copyShareUrl()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shareUrl])

  const copyShareUrl = () => {
    if (navigator.clipboard) {
      return navigator.clipboard.writeText(shareUrl)
    }
    const elem = document.getElementById("share-url-text");
    if (elem) {
      elem.focus();
    }
  }

  return (
    <ModalInstance modalId="modal.contact" {...props} title={t('modal.contact_heading')} size={Size.L}>
        <>
            <Flex
            alignContent="stretch"
            justifyContent="space-between"
            flexDirection="column"
            flexWrap="nowrap"
            alignItems="flex-start"
            >
                <BodyText>
                  {t('modal.contact_text')}
                </BodyText>
                <BodyText>
                  {t('modal.contact_share_text')}
                </BodyText>
                <Heading level={3}>
                  {t('modal.contact_copy_text')}:
                </Heading>
                <div className="indigo-copy-wrapper">
                  <Form
                      isCentered={false}
                      mode={"wide"}
                  >
                      <Form.Item>
                          <TextArea
                          id="share-url-text"
                          rows={3}
                          value={shareUrl}
                          width={Size.XXL}
                          />
                      </Form.Item>
                  </Form>
                  <Button className="copy-button copy-button copy-button-color-aqua-medium" buttonType={ButtonType.Link} endIcon={<Icon name={VaiIcon.Copy} />} onClick={() => copyShareUrl()}>
                    {t('modal.shareButton')}
                  </Button>
                </div>
                <a href="https://www.vaisala.com/en/lp/indigo-selector/contact-sales" className="contact-button vai-button vai-button--primary vai-button--m">
                    <span className="vai-button__text">{t('modal.contact_button')}</span>
                </a>
            </Flex>
        </>
    </ModalInstance>
  );
};

export default ContactModal;
